import { addYears } from 'date-fns'
import { CorrectionField, RecognitionErrorsResponse } from '~/shared/api'
import { formatDateForApi } from '~/shared/lib/date'
import { FIELD_LABELS, DOCUMENT_TYPE_LABELS } from '../constants'

export const getFieldLabel = (fieldName: string): string => {
  return FIELD_LABELS[fieldName] || fieldName
}

export const getDocumentTypeLabel = (
  documentType: 'driver-license-front' | 'driver-license-back' | 'passport',
): string => {
  return DOCUMENT_TYPE_LABELS[documentType] || documentType
}

export const extractCorrectionFields = (
  errorsData: RecognitionErrorsResponse,
): CorrectionField[] => {
  const fieldsMap: Record<string, CorrectionField> = {}

  Object.entries(errorsData).forEach(([documentType, data]) => {
    if (!data?.errors || data.errors.length === 0) return

    data.errors.forEach((errorFieldName) => {
      if (fieldsMap[errorFieldName]) return

      fieldsMap[errorFieldName] = {
        documentType: documentType as CorrectionField['documentType'],
        fieldName: errorFieldName,
        label: getFieldLabel(errorFieldName),
        currentValue: data.entities[errorFieldName] || '',
      }
    })
  })

  return Object.values(fieldsMap)
}

export const groupFieldsByDocument = (
  fields: CorrectionField[],
): Record<string, CorrectionField[]> => {
  return fields.reduce((acc: Record<string, CorrectionField[]>, field) => {
    const key = field.documentType
    if (!acc[key]) {
      acc[key] = []
    }
    acc[key].push(field)
    return acc
  }, {})
}

export const isDateField = (fieldName: string): boolean => {
  const dateFields = [
    'birthDate',
    'passportIssueDate',
    'drivingLicenseIssueDate',
    'drivingLicenseExpirationDate',
    'drivingExperienceStartDate',
  ]
  return dateFields.includes(fieldName)
}

export const isDaDataField = (fieldName: string): boolean => {
  const daDataFields = [
    'passportIssued',
    'divisionCode',
    'registrationAddress',
    'placeOfResidence',
    'birthPlace',
  ]
  return daDataFields.includes(fieldName)
}

export const isFmsField = (fieldName: string): boolean => {
  return fieldName === 'passportIssued' || fieldName === 'divisionCode'
}

export const getDatePickerMaxDate = (fieldName: string): string | undefined => {
  if (fieldName === 'drivingLicenseExpirationDate') {
    return formatDateForApi(addYears(new Date(), 20))
  }
  return undefined
}
